import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "+1",
    orderNumber: "",
    reason: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 重置表单
    setFormData({
      name: "",
      email: "",
      phone: "",
      countryCode: "+1",
      orderNumber: "",
      reason: "",
    });
    alert(
      "Your return request has been submitted. We will email you return instructions soon."
    );
  };

  return (
    <div className="color-scheme color-scheme--scheme-1">
      <Header />

      <div className="returns-page">
        <div className="returns-container">
          {/* Policy Section */}
          <div className="policy-section">
            <h1>Return And Refund Policy Overview</h1>

            <div className="policy-content">
              <p>
                Sadiemall accepts returns on most unopened and unused products
                within 30 days of the order being received.
              </p>

              <p>Customers are responsible for return shipping costs.</p>

              <p>
                Certain items cannot be returned, including: any opened or used
                products, special orders, homeopathic products, refrigerated
                products, hair brushes, combs, toothbrushes, shaving brushes,
                razors, shaving tools, manicure/pedicure tools, sponges,
                menstrual cups, and bath items such as washcloths and back
                scrubbers, even if they are not opened or used.
              </p>

              <h2>How To Start A Return</h2>

              <p>
                All returns must be authorized in advance. To receive an
                authorization, please fill out the form below with your name,
                order number, and the reason for the return and we will email
                you return instructions.
              </p>
            </div>
          </div>

          {/* Form Section */}
          <div className="return-form-section">
            <form onSubmit={handleSubmit} className="return-form">
              <div className="form-group">
                <label htmlFor="name">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  Email<span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group phone-group">
                <label htmlFor="phone">
                  Phone Number<span className="required">*</span>
                </label>
                <div className="phone-input-wrapper">
                  <select
                    name="countryCode"
                    value={formData.countryCode}
                    onChange={handleChange}
                    className="country-code"
                  >
                    <option value="+1">United States +1</option>
                    <option value="+44">United Kingdom +44</option>
                    <option value="+86">China +86</option>
                    <option value="+81">Japan +81</option>
                    <option value="+82">Korea +82</option>
                    <option value="+33">France +33</option>
                    <option value="+49">Germany +49</option>
                  </select>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="phone-number"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="orderNumber">
                  Order Number<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="orderNumber"
                  name="orderNumber"
                  value={formData.orderNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="reason">
                  Reason for return<span className="required">*</span>
                </label>
                <textarea
                  id="reason"
                  name="reason"
                  rows="5"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
